import { NegotiationCommitType } from "@src/app/rateNegotiation/interfaces";

const REMOVE_LICENSE_MODAL = {
  TITLE: "Remove License",
  CONTENT:
    "Are you sure you want to remove this license from your account? This means you will no longer be able to work shifts in this state.",
};

const RATE_NEGOTIATION_COMMIT_MODAL = {
  [NegotiationCommitType.PROPOSE_NEW_RATE]: {
    TITLE: "Propose New Rate",
    CONTENT: (rate) =>
      `If the workplace accepts your proposal you will be booked for this shift. Do you want to propose that the rate for this shift should be $${rate}/hr?`,
    SUB_CONTENT: "You can book the shift at the current posted rate at any time.",
    BUTTON_TEXT: "Propose Rate",
  },
  [NegotiationCommitType.END_NEGOTIATION]: {
    TITLE: "End Negotiation",
    CONTENT:
      "When you end a negotiation you won't be able to propose another rate for the same shift. Are you sure you want to end this shift rate negotiation?",
    SUB_CONTENT: "You will still be able to book the shift at the Workplace's posted rate.",
    BUTTON_TEXT: "End Negotiation",
  },
};
export { REMOVE_LICENSE_MODAL, RATE_NEGOTIATION_COMMIT_MODAL };
